import { render, staticRenderFns } from "./SupplierTablePage.vue?vue&type=template&id=41d6968c"
import script from "./SupplierTablePage.vue?vue&type=script&lang=js"
export * from "./SupplierTablePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports